import { z } from "zod";
export const INTEGRATION_PROVIDERS = ["FAKE_CORE", "TOTVS_RM", "SENIOR_HCM"];
/** Credenciais enviadas uma vez — nunca persistidas no banco. */
export const integrationCredentialsSchema = z
    .object({
    clientId: z.string().min(1).max(256).optional(),
    clientSecret: z.string().min(1).max(1024).optional(),
    username: z.string().min(1).max(256).optional(),
    password: z.string().min(1).max(1024).optional(),
    apiKey: z.string().min(1).max(1024).optional(),
})
    .refine((c) => Boolean(c.clientSecret || c.password || c.apiKey || c.clientId || c.username), { message: "Informe ao menos um campo de credencial" });
export const createIntegrationSchema = z.object({
    provider: z.enum(INTEGRATION_PROVIDERS),
    baseUrl: z.string().url().max(2048).optional(),
    companyId: z.string().min(1).max(64).optional(),
    credentials: integrationCredentialsSchema,
});
export const updateIntegrationSchema = z
    .object({
    baseUrl: z.string().url().max(2048).nullable().optional(),
    companyId: z.string().min(1).max(64).nullable().optional(),
    credentials: integrationCredentialsSchema.optional(),
})
    .refine((b) => b.baseUrl !== undefined || b.companyId !== undefined || b.credentials !== undefined, { message: "Nada para atualizar" });
export const SYNC_ENTITIES = [
    "employees",
    "companies",
    "departments",
    "positions",
    "payroll",
    "vacations",
];
/** Body POST /v1/integrations/:id/sync (FASE-06-T22). */
export const manualSyncSchema = z.object({
    entity: z.enum(SYNC_ENTITIES),
});
//# sourceMappingURL=integration.js.map